import React from "react";
import { useNavigate } from "react-router-dom";

import { ResetPassword } from "@examspark/common-app";

const ResetPasswordRoute = () => {
  const navigate = useNavigate();
  return <ResetPassword onBackToLogin={() => navigate("/login")} />;
};

export default ResetPasswordRoute;
